<template>
    <div class="main-wrapper">
        <div class="auth-wrapper d-flex no-block justify-content-center align-items-center" style="background:url(/assets/img/auth-bg.jpg) no-repeat center center;">
            <div class="auth-box">
                <div id="loginform">
                    <div class="logo">
                        <span class="db"><h1>#ZGH</h1></span>
                        <h4 class="font-medium mb-3 db dezaficher">Réinitialisation mot de passe 👇</h4>
                    </div>
                    <!-- Form -->
                    <div class="row">
                        <div class="col-12">
                            <ul v-if="errors.length>0" class="text-center text-danger font-weight-bold list-unstyled">
                                <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
                            </ul>
                            <form class="form-horizontal mt-3" id="loginform" @submit.prevent="resetPassword">
                                <div id="messagec" hidden="">
                                    <div class="row justify-content-center">
                                        <div class="col-md-12 text-center">
                                            <div class="mb-4 lead text-success">Mot de passe modifié avec succès.</div>
                                            <a href="/" class="btn btn-link">Connecter</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="input-group mb-3 dezaficher">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon2">
                                        <i class="fa fa-lock"></i>
                                    </span>
                                    </div>
                                    <input :type="passwordFieldType" v-model="passzgh" required class="form-control form-control-lg" placeholder="Nouveau mot de passe"
                                        aria-label="repassword"
                                        aria-describedby="basic-addon1"
                                        id="password"
                                    />
                                    <div class="input-group-append">
                                    <span class="input-group-text" @click="showPassword('password')">
                                        <i :class="passwordFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                                    </span>
                                    </div>
                                </div>
                                <!-- Repeter Password -->
                                <div class="input-group mb-3 dezaficher">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon2">
                                        <i class="fa fa-lock"></i>
                                    </span>
                                    </div>
                                    <input
                                    :type="repasswordFieldType" v-model="repasszgh" required
                                    class="form-control form-control-lg"
                                    placeholder="Répéter mot de passe"
                                    aria-label="repassword"
                                    aria-describedby="basic-addon1"
                                    id="repassword"
                                    />
                                    <div class="input-group-append">
                                    <span class="input-group-text" @click="showPassword('repassword')">
                                        <i :class="repasswordFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                                    </span>
                                    </div>
                                </div>
                                <div class="form-group text-center dezaficher">
                                    <div class="col-xs-12 pb-3">
                                        <button class="btn btn-block btn-lg" style="background:#00C853; color: #fff;" :disabled="!passzgh || !repasszgh" type="submit">Réinitialiser</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    const base_url=process.env.VUE_APP_API_URL;
    export default {
        name:'PasswordReset',
        data() {
            return {
                code:'',
                passzgh: '',
                repasszgh: '',
                errors:[],
                passwordFieldType: 'password',
                repasswordFieldType: 'password',
            }
        },
        created() {
            if (this.$route.params.id) {
                this.code = this.$route.params.id;
                // console.log(this.code);
            }
        },
        mounted() {
        // Créer un élément de lien et l'ajouter au head du document
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/assets/css/styles.min.css';
        document.head.appendChild(link);        
    },
    methods:{
        async resetPassword() {
            const control = !!(this.passzgh && this.repasszgh && this.code && (this.passzgh===this.repasszgh));
            console.log(control);
            this.errors=[];
                if(this.passzgh==='' || this.passzgh.length==0){
                    this.errors.push("Ajouter mot de passe!");
                }
                if(this.repasszgh==='' || this.repasszgh.length==0){
                    this.errors.push("Répéter mot de passe!");
                }
                if(this.passzgh!==this.repasszgh || this.passzgh.length!==this.repasszgh.length){
                    this.errors.push("Mot de passe non identique!");
                }
              console.log(this.errors);
                // return false;
              if(this.errors.length===0 && control===true){      
                //   return false;
                    axios.post(`${base_url}/auth/pwdrst`, {
                        password: this.passzgh,
                        id: this.code,
                    })
                    .then((response)=>{
                        // console.log(response.data);
                        // return false;
                        if(response.status==200){
                            this.showMessage();
                        }
                    })
                    .catch((error)=>{
                        console.log('Une erreur est survenue lors de la connexion');
                        console.error(error);
                        
                    }) 
                }         
        },
        showPassword(identifier) {
            if(identifier=='password'){
                const passwordField = document.getElementById('password');
                const type = passwordField.getAttribute('type') === 'password' ? 'text' : 'password';
                passwordField.setAttribute('type', type);
                this.passwordFieldType = type; // Update the data property to reflect the current type
            }
            if(identifier=='repassword'){
                const passwordField = document.getElementById('repassword');
                const type = passwordField.getAttribute('type') === 'password' ? 'text' : 'password';
                passwordField.setAttribute('type', type);
                this.repasswordFieldType = type; // Update the data property to reflect the current type
            }            
        },
        showMessage(){
            const elements = document.querySelectorAll('.dezaficher');
                elements.forEach(element => {
                    element.setAttribute('hidden', true);
                });
            document.getElementById("messagec").removeAttribute("hidden");
        }
    }
}
</script>

<style scoped>
.fa, .db{color: #00C853;}
.password-container {
  position: relative;
  width: fit-content;
}
.password-container input {
  padding-right: 30px; /* space for the icon */
}
.password-container .fa-eye, 
.password-container .fa-eye-slash {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>